import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Label, Row } from "reactstrap"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { getProviderItems } from "store/provider-dashboard/provider-dashboard-action"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"
import { isObject } from "lodash"
import { getItems } from "store/admin/admin-dashboard-action"

const ProviderReceiptsActionRequestFilters = ({
  onAdvancedSearchSubmit,
  loading,
}) => {
  const expireFlatpickerfrom = useRef(null)
  const expireFlatpickerto = useRef(null)
  const receiptFlatpickerfrom = useRef(null)
  const receiptFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [user, setUser] = useState(null)
  const [project, setProject] = useState(null)
  const [expireDate, setExpireDate] = useState({
    from: null,
    to: null,
  })
  const [receiptDate, setReceiptDate] = useState({
    from: null,
    to: null,
  })
  const items = useSelector(state => state.adminDashboard.Items)
  const projects = useSelector(state => state.adminDashboard.Projects)
  const categories = useSelector(state => state.adminDashboard.ItemCategoires)
  const users = useSelector(state => state.adminDashboard.users)

  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  const dispatch = useDispatch()

  const handleSubmit = () => {
    let data = {}
    data.item = isObject(item) ? item.value : null
    data.project = isObject(project) ? project.value : null
    data.category = isObject(category) ? category.value : null
    data.user = isObject(user) ? user.value : null
    data.expireDate = {
      from: expireDate.from ? expireDate.from : null,
      to: expireDate.to ? expireDate.to : null,
    }
    data.receiptDate = {
      from: receiptDate.from ? receiptDate.from : null,
      to: receiptDate.to ? receiptDate.to : null,
    }
    onAdvancedSearchSubmit(data)
  }

  const onCategoryChangeHandler = cate => {
    setCategory(cate)
    dispatch(getItems(cate.value))
  }

  const onItemChangeHandler = item => {
    setItem(item)
  }
  const onProjectChangeHandler = value => {
    setProject(value)
  }
  const onUserChangeHandler = value => {
    setUser(value)
  }

  const onClearHandler = () => {
    expireFlatpickerfrom.current.flatpickr.clear()
    expireFlatpickerto.current.flatpickr.clear()
    receiptFlatpickerfrom.current.flatpickr.clear()
    receiptFlatpickerto.current.flatpickr.clear()
    setCategory(null)
    setItem(null)
    setExpireDate({ from: null, to: null })
    setReceiptDate({ from: null, to: null })
    setProject(null)
    onAdvancedSearchSubmit({})
    dispatch(providerDashboardAction.resetProviderItems())
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Users</Label>
            {users?.data && (
              <Select
                options={users?.data}
                value={user}
                onChange={onUserChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                options={projects?.data}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category || categories?.data[0]}
                onChange={onCategoryChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                options={[{ value: "all", label: "All" }, ...filteredItems]}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Label className="form-label">Expire Date</Label>
        <Row>
          <Col>
            <Flatpickr
              ref={expireFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setExpireDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Flatpickr
              ref={expireFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setExpireDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Label className="form-label">Receipt Date</Label>
        <Row>
          <Col>
            <Flatpickr
              ref={receiptFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setReceiptDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Flatpickr
              ref={receiptFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setReceiptDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderReceiptsActionRequestFilters
